// removed by extract-text-webpack-plugin
module.exports = {"paginationBox":"Pagination__paginationBox__DQwL2","paginationCount":"Pagination__paginationCount__1Hog4","paginations":"Pagination__paginations__2-z4D","changePagination":"Pagination__changePagination__3Hfot","paginationInput":"Pagination__paginationInput__3dIIC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pagination/Pagination.styl
// module id = 443
// module chunks = 0